import { render, staticRenderFns } from "./TeacherItem.vue?vue&type=template&id=232e6d9b&scoped=true"
import script from "./TeacherItem.vue?vue&type=script&lang=ts"
export * from "./TeacherItem.vue?vue&type=script&lang=ts"
import style0 from "./TeacherItem.vue?vue&type=style&index=0&id=232e6d9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e6d9b",
  null
  
)

export default component.exports